const DEFAULT_ENVIRONMENT = 'production';

export { DEFAULT_ENVIRONMENT };
//# sourceMappingURL=constants.js.map



// WEBPACK FOOTER //
// ./node_modules/@sentry/core/esm/constants.js